export const BOTULINUM_FORM_ARCHIVED = "7021000";

export const BOTULINUM_FORM_FIELDS_ARCHIVED = Object.freeze({
  LOCATIONS: "191611108",
  SIDES_INJECTED: "193165904",
  FURTHER_INJECTION_DETAILS: "193165018",
  INJECTATES: "191611110",
  INJECTATE_QUANTITY: "193166569",
  OUTCOME: "193166570",
  POST_PROCEDURE_COMMENTS: "193191715",
} as const);

export type BotulinumFormFields_Archived =
  keyof typeof BOTULINUM_FORM_FIELDS_ARCHIVED;

export const BOTULINUM_FORM_FIELDS_SET_ARCHIVED = new Set(
  (
    Object.keys(
      BOTULINUM_FORM_FIELDS_ARCHIVED,
    ) as BotulinumFormFields_Archived[]
  ).map(
    (key: BotulinumFormFields_Archived) => BOTULINUM_FORM_FIELDS_ARCHIVED[key],
  ),
);

/* New Form */

export const BOTULINUM_REQUIRED_FIELDS_ARCHIVED = [
  BOTULINUM_FORM_FIELDS_ARCHIVED.SIDES_INJECTED,
  BOTULINUM_FORM_FIELDS_ARCHIVED.INJECTATE_QUANTITY,
];

export const BOTULINUM_FORM = "7255069";

export const BOTULINUM_FIELDS = Object.freeze({
  GENERAL_RISK: "198564009",
  RISK_OF_PTX: "198564010",
  INJECTATES: "198564017",
  INJECTATE_QUANTITY: "198564018",
  CLEANING_AGENT: "198564011",
  ULTRASOUND_GUIDANCE: "198564016",
  LOCATION_1: "198564012",
  LOCATION_2: "198686902",
  LOCATION_3: "198686913",
  LOCATION_4: "198686920",
  LOCATION_5: "198686917",
  UNITS_1: "198686005",
  UNITS_2: "198686903",
  UNITS_3: "198686914",
  UNITS_4: "198686922",
  UNITS_5: "198686918",
  SIDE_1: "198684731",
  SIDE_2: "198686904",
  SIDE_3: "198686915",
  SIDE_4: "198686922",
  SIDE_5: "198686919",
  ADDITIONAL_LOCATIONS_CHECKBOX: "198772118",
  ADDITIONAL_LOCATION_1: "198780387",
  ADDITIOnAL_LOCATION_2: "198780390",
  ADDITIOnAL_LOCATION_3: "198780393",
  ADDITIONAL_UNITS_1: "198780388",
  ADDITIONAL_UNITS_2: "198780391",
  ADDITIONAL_UNITS_3: "198780394",
  ADDITIONAL_SIDE_1: "198780389",
  ADDITIONAL_SIDE_2: "198780392",
  ADDITIONAL_SIDE_3: "198780395",
  PATIENT_POSITION: "198564015",
  INJECTION_NEEDLE: "198564019",
  LOT_NUMBER_AND_EXPIRATION: "198564023",
  FURTHER_INJECTION_DETAILS: "198564014",
  OUTCOME: "198564020",
  POST_PROCEDURE_COMMENTS: "198564021",
} as const);

export type BotulinumFields = keyof typeof BOTULINUM_FIELDS;

export const BOTULINUM_FIELD_SET = new Set(
  (Object.keys(BOTULINUM_FIELDS) as BotulinumFields[]).map(
    (key: BotulinumFields) => BOTULINUM_FIELDS[key],
  ),
);

export const BOTULINUM_REQUIRED_FIELDS = [
  BOTULINUM_FIELDS.INJECTATES,
  BOTULINUM_FIELDS.INJECTATE_QUANTITY,
  BOTULINUM_FIELDS.CLEANING_AGENT,
  BOTULINUM_FIELDS.SIDE_1,
  BOTULINUM_FIELDS.INJECTION_NEEDLE,
];

export const MIGRAINE_INJECTION_FORM = "7362478";

export const MIGRAINE_INJECTION_FORM_FIELDS = Object.freeze({
  INJECTATE: "201762171",
  TOTAL_UNITS: "201762172",
  TOTAL_CC: "201762173",
  FURTHER_INJECTION_DETAILS: "201762565",
  POST_PROCEDURE_COMMENTS: "201762566",
  IS_CORRUGATOR: "201990632",
  CORRUGATOR_TOTAL_UNITS: "201990633",
  IS_PROCERUS: "201990642",
  PROCERUS_TOTAL_UNITS: "201990643",
  IS_FRONTALIS: "201990645",
  FRONTALIS_TOTAL_UNITS: "201990646",
  IS_TEMPORALIS: "201990650",
  TEMPORALIS_TOTAL_UNITS: "201990651",
  IS_OCCIPITALIS: "201990655",
  OCCIPITALIS_TOTAL_UNITS: "201990656",
  IS_CERVICAL_PARASPINALS: "201990660",
  CERVICAL_PARASPINALS_TOTAL_UNITS: "201990661",
  IS_TRAPEZIUS: "201990665",
  TRAPEZIUS_TOTAL_UNITS: "201990666",
} as const);

export type MigraineInjectionFormFields =
  keyof typeof MIGRAINE_INJECTION_FORM_FIELDS;

export const MIGRAINE_INJECTION_FORM_FIELD_SET = new Set(
  (
    Object.keys(MIGRAINE_INJECTION_FORM_FIELDS) as MigraineInjectionFormFields[]
  ).map(
    (key: MigraineInjectionFormFields) => MIGRAINE_INJECTION_FORM_FIELDS[key],
  ),
);

export const MIGRAINE_INJECTION_FORM_REQUIRED_FIELDS = [
  MIGRAINE_INJECTION_FORM_FIELDS.INJECTATE,
  MIGRAINE_INJECTION_FORM_FIELDS.TOTAL_UNITS,
  MIGRAINE_INJECTION_FORM_FIELDS.TOTAL_CC,
];
